export default () => next => action => {
  if (!action.promise) {
    return next(action);
  }
  next({
    ...action,
    type: action.type.PENDING,
  });
  const actionPromise = new Promise((resolve, reject) => (
    action.promise
      .then(response => {
        const obj = { ...action, type: action.type.RESOLVED, ...response };
        next(obj);
        return resolve(
          obj
        );
      })
      .catch(error => reject(
        next({ ...action, type: action.type.REJECTED, error })
      ))
  ));
  return actionPromise;
};
